import { createContext, Ref } from 'preact';
import { useContext } from 'preact/hooks';

interface ProductCardContextValue {
  /** Which face is showing. The front is the default; the what's-included face slides over it. */
  showWhatsIncluded: boolean;
  setShowWhatsIncluded: (show: boolean) => void;
  /**
   * The two faces register themselves here so `Root` can measure whichever one is showing. Refs
   * rather than children, because the height animation needs the real element, and only the face
   * itself knows which node that is.
   */
  frontRef: Ref<HTMLDivElement>;
  whatsIncludedRef: Ref<HTMLDivElement>;
}

export const ProductCardContext = createContext<ProductCardContextValue | null>(null);

/**
 * Read the card's flip state. Exported because a card sometimes needs it directly — the sponsorship
 * card's what's-included button returns to the front when no tier has been chosen yet.
 */
export const useProductCard = () => {
  const context = useContext(ProductCardContext);
  if (!context) {
    throw new Error('ProductCard parts must be rendered inside <ProductCard.Root>');
  }
  return context;
};
